import { Loader, Show } from 'shared';

import { useNextSessionQuery } from 'features/participants/hooks';
import { SessionSidebar } from 'features/sessions/components';
import { NextSessionCoachFormWithHeader } from 'features/sessions/components/NextSessionForm/Sidebar';
import { NextSessionErrorState } from 'features/sessions/components/NextSessionForm/Sidebar/NextSessionErrorState';

export const NextSessionSidebar = ({
  coachingSessionId,
}: {
  coachingSessionId: string;
}) => {
  const {
    data: sessionPrepInfo,
    isLoading,
    isError,
  } = useNextSessionQuery(coachingSessionId);

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <NextSessionErrorState />;
  }

  return (
    <Show when={!!sessionPrepInfo}>
      <SessionSidebar width="auto">
        <NextSessionCoachFormWithHeader sessionAppointment={sessionPrepInfo} />
      </SessionSidebar>
    </Show>
  );
};
